import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e6a061a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "chartter"
};
const _hoisted_3 = {
  class: "score-header"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "Metric Evolution", -1));
const _hoisted_6 = {
  class: "selected"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "last"
}, " Last ", -1));
const _hoisted_8 = {
  class: "overflow-wrapper"
};
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = {
  class: "score-controllers"
};
const _hoisted_11 = {
  class: "wrapper"
};
const _hoisted_12 = {
  class: "chart-toolbar"
};
const _hoisted_13 = {
  class: "footer"
};
const _hoisted_14 = {
  class: "tools"
};
const _hoisted_15 = {
  class: "switches"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, " Export chart ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_clear_icon = _resolveComponent("clear-icon");
  const _component_switch_vertical_icon = _resolveComponent("switch-vertical-icon");
  const _component_evolution_chart_controller = _resolveComponent("evolution-chart-controller");
  const _component_evolution_chart_footer_item = _resolveComponent("evolution-chart-footer-item");
  const _component_chart_theme_dropdown = _resolveComponent("chart-theme-dropdown");
  const _component_align_top_icon = _resolveComponent("align-top-icon");
  const _component_app_button = _resolveComponent("app-button");
  const _component_b_modal = _resolveComponent("b-modal");
  const _component_evolution_chart_export_modal = _resolveComponent("evolution-chart-export-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_b_modal, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $options.modal = $event),
    centered: "",
    "no-fade": "",
    "hide-footer": "",
    "hide-header": "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    class: "evolution-chart-modal",
    onShown: $options.onModalShown
  }, {
    default: _withCtx(() => [!$props.chartEngine ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading chart...")) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_app_dropdown, {
      class: "period-dropdown",
      arrow_icon_color: "#2172E1"
    }, {
      "button-content": _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createTextVNode(" " + _toDisplayString($props.chartEngine?.chartPeriod.period.text), 1)])]),
      body: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chartEngine?.chartPeriod.periods, value => {
        return _openBlock(), _createBlock(_component_b_dropdown_item, {
          key: value.key,
          onClick: $event => $props.chartEngine.setChartPeriod(value),
          active: $props.chartEngine.chartPeriod.period.key == value.key
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(value.text), 1)]),
          _: 2
        }, 1032, ["onClick", "active"]);
      }), 128))]), _createElementVNode("div", {
        class: "exclude-action",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [_createVNode(_component_b_form_checkbox, {
        name: "exclude-current-period",
        id: "exclude-current-period",
        modelValue: $props.chartEngine.chartPeriod.currentPeriodExcluded,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.chartEngine.chartPeriod.currentPeriodExcluded = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("Exclude current period")]),
        _: 1
      }, 8, ["modelValue"])])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_clear_icon, {
      class: "clear-icon",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('update:modelValue', false))
    })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "vertical-switch",
      onClick: _cache[3] || (_cache[3] = $event => {
        $props.chartEngine.swap();
        _ctx.$emit('refresh-chart');
      })
    }, [_createVNode(_component_switch_vertical_icon)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_evolution_chart_controller, {
      title: "Metric 1",
      color: $options.metric1?.color,
      modelValue: $options.metric1,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $options.metric1 = $event),
      options: $options.flattenedOptions,
      onToggleVisibility: _cache[5] || (_cache[5] = $event => $props.chartEngine.metric1.toggleVisibility()),
      compare: $options.metric1Evolution,
      "onUpdate:compare": _cache[6] || (_cache[6] = $event => $options.metric1Evolution = $event),
      compareOptions: $options.metric1.evolution.options,
      "show-evolution": ""
    }, null, 8, ["color", "modelValue", "options", "compare", "compareOptions"]), _createVNode(_component_evolution_chart_controller, {
      title: "Metric 2",
      color: $options.metric2?.color,
      modelValue: $options.metric2,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $options.metric2 = $event),
      options: $options.flattenedOptions,
      onToggleVisibility: _cache[8] || (_cache[8] = $event => $props.chartEngine.metric2.toggleVisibility())
    }, null, 8, ["color", "modelValue", "options"])])]), _createElementVNode("div", {
      class: "chart-wrapper",
      style: _normalizeStyle({
        backgroundColor: $props.chartEngine.theme?.background,
        ['--text-color']: $props.chartEngine.theme?.color
      })
    }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_b_form_checkbox, {
      modelValue: $props.chartEngine.showLabels,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $props.chartEngine.showLabels = $event),
      name: "chart-show-label"
    }, {
      default: _withCtx(() => [_createTextVNode("Show labels")]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_b_form_checkbox, {
      modelValue: $props.chartEngine.matchScale,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $props.chartEngine.matchScale = $event),
      name: "chart-match-scale"
    }, {
      default: _withCtx(() => [_createTextVNode("Match scale")]),
      _: 1
    }, 8, ["modelValue"])]), $props.chartEngine.chartType === 'line-chart' ? _renderSlot(_ctx.$slots, "line-chart", {
      key: 0,
      x2Label: $options.metric1.evolution.label,
      metricColor: $options.metric1.color,
      showEvolution: $props.chartEngine.metric1.showEvolution
    }, undefined, true) : _createCommentVNode("", true), $props.chartEngine.chartType === 'bar-chart' ? _renderSlot(_ctx.$slots, "bar-chart", {
      key: 1,
      showEvolution: $props.chartEngine.metric1.showEvolution,
      x2Label: $options.metric1.evolution.label,
      metricColor: $options.metric1.color
    }, undefined, true) : _createCommentVNode("", true), $props.chartEngine.chartType === 'bar-line-chart' ? _renderSlot(_ctx.$slots, "bar-line-chart", {
      key: 2,
      showEvolution: $props.chartEngine.metric1.showEvolution,
      x2Label: $options.metric1.evolution.label,
      metricColor: $options.metric1.color
    }, undefined, true) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_evolution_chart_footer_item, null, {
      title: _withCtx(() => [_createTextVNode(" Chart type ")]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chartEngine.chartTypes, ({
        key
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{
            active: $props.chartEngine.chartType === key
          }, "switch"]),
          onClick: $event => $options.selectChart(key)
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent($data.icons[key]), {
          width: "16",
          height: "16",
          color: $props.chartEngine.chartType === key ? 'var(--market-800)' : '#999999'
        }, null, 8, ["color"]))], 10, _hoisted_16);
      }), 256))])]),
      _: 1
    }), _createVNode(_component_evolution_chart_footer_item, null, {
      title: _withCtx(() => [_createTextVNode(" Chart colors ")]),
      default: _withCtx(() => [$props.chartEngine ? (_openBlock(), _createBlock(_component_chart_theme_dropdown, {
        key: 0,
        themes: $props.chartEngine?.getChartThemes,
        modelValue: $props.chartEngine.theme,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $props.chartEngine.theme = $event)
      }, null, 8, ["themes", "modelValue"])) : _createCommentVNode("", true)]),
      _: 1
    })]), _createVNode(_component_app_button, {
      class: "export-chart",
      onClick: _cache[12] || (_cache[12] = $event => $data.exportModal = true),
      disabled: $data.exporting
    }, {
      default: _withCtx(() => [_createVNode(_component_align_top_icon, {
        color: "var(--market-950)"
      }), _hoisted_17]),
      _: 1
    }, 8, ["disabled"])])]))]),
    _: 3
  }, 8, ["modelValue", "onShown"]), _createVNode(_component_evolution_chart_export_modal, {
    modelValue: $data.exportModal,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.exportModal = $event),
    "show-axes": $data.showExportAxes,
    "onUpdate:showAxes": _cache[15] || (_cache[15] = $event => $data.showExportAxes = $event),
    onResize: _cache[16] || (_cache[16] = options => _ctx.$emit('resize', options)),
    onCopyChart: $options.handleExport
  }, null, 8, ["modelValue", "show-axes", "onCopyChart"])], 64);
}